<div class="pagination" [ngClass]="{'--new-brand' : newBrand}">
  <form [formGroup]="formPagination" data-test="formLimitPagination" class="pagination__limit-list">
    <label for="limit">Exibir por página</label>
    <div class="select --dark">
      <select formControlName="limit" data-test="btnLimitPagination" id="limit">
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
  </form>
  <ng-container *ngIf="total > formPagination.get('limit').value">
    <pagination-controls (pageChange)="onChange($event)" previousLabel="" id="server"  nextLabel=""></pagination-controls>
  </ng-container>
</div>
